export default __webpack_public_path__ + "images/chart-outline-white.b52df84082d10d9b88c38bb33b633027.png";